export type ConsentCategory = "necessary" | "analytics" | "marketing";

export interface ConsentState {
  necessary: boolean; // Always true
  analytics: boolean;
  marketing: boolean;
  version: number;
  timestamp: string;
}

export const DEFAULT_CONSENT: ConsentState = {
  necessary: true,
  analytics: false,
  marketing: false,
  version: 1, // Start with version 1
  timestamp: "",
};

// Global augmentation for the ConsentManager API
declare global {
  interface Window {
    ThemeConsent: {
      init: () => void;
      update: (consent: ConsentState) => void;
      getConsent: () => ConsentState | null;
    };
  }
}
